import { useEffect, useState } from "react";
import Kpi from "../KPI/Kpi";
import { Box, Grid } from "@mui/material";
import ProgressBar from "../ProgressBar/ProgressBar";

export function KpisAreaAtuacao({
  app,
  idNumberFrist,
  idNumberSecond,
  idNumberPercentage,
  idPercentageProgress,
  days,
}) {
  const [percentageProgressBar, setPercentageProgressBar] = useState(0);

  const [numberFrist, numberSecond, numberPercentage, percentageProgress] = [
    Kpi({
      app,
      objectId: idNumberFrist,
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: idNumberSecond,
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: idNumberPercentage,
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: idPercentageProgress,
      updatesWithSelection: true,
    }),
  ];

  useEffect(() => {
    const num = percentageProgress ? parseFloat(percentageProgress) : 0;
    setPercentageProgressBar(num > 100 ? 100 : num);
  }, [percentageProgress]);

  return (
    <>
      <Grid
        container
        item
        flexDirection={"row"}
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
        rowGap={1}
        sx={{
          padding: "0px 12px 4px 0",
        }}
      >
        <Grid
          className={`value-wrapper`}
          container
          item
          xs={12}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          sx={{
            width: "100%",
          }}
        >
          <Grid
            item
            container
            xs
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            columnGap={1}
            sx={{
              marginBottom: "4px",
            }}
          >
            {/* Primeiro número recebido */}
            <Box
              component={"span"}
              className="value"
              style={{
                color: "#E95248",
              }}
            >
              {days ? (
                <>
                  <span>Restam</span> {numberFrist} <span>dias</span>
                </>
              ) : (
                <>
                  {numberFrist} <span>a realizar</span>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
        {/* PROGRESS BAR */}
        <Grid
          container
          item
          flexDirection={"column"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
          style={{
            width: "100%",
          }}
          xs={12}
        >
          <ProgressBar
            style={{ maxWidth: "137px" }}
            key={"Sell out"}
            bgColor={"#6392C3"}
            completed={percentageProgressBar}
          />
        </Grid>
        {/* Números e textos */}
        <Grid className="container-numbers-indicadores">
          <span className="numbers"> {numberSecond} </span>{" "}
          <span className="texts">{days ? "dias no total" : "Realizado"}</span>
          <span className="numbers-percente"> {numberPercentage} </span>{" "}
          <span className="texts">{days ? "do período" : "A atingir"}</span>
        </Grid>
      </Grid>
    </>
  );
}
